import { Component, OnInit, Inject,ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Requerimientos3Service } from "app/main/pagina/tools/requerimientos3/requerimientos3.service";
import {TranslateService} from '@ngx-translate/core';
import { lang_requerimientos } from 'app/idiomas/i18n/requerimientos/requerimientos.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import Swal from 'sweetalert2';
import { DATOS_API } from 'app/auth/auth.datos';
@Component({
  selector: 'app-form-ayuda',
  templateUrl: './form-ayuda.component.html',
  styleUrls: ['./form-ayuda.component.scss']
})
export class FormAyudaComponent implements OnInit {
idiomaNativo:any;
description="";
  urlAssetsEmail= DATOS_API.urlAssets;
  constructor(
      @Inject(MAT_DIALOG_DATA) public datos: any,
      public dialogRef: MatDialogRef<FormAyudaComponent>,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private reqService: Requerimientos3Service,
  ) {
    lang_requerimientos.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
this.idiomaNativo=this.translateSrv.currentLang;
  }

  ngOnInit(): void {
    console.log('datos',this.datos);
    console.log('idiomaNativo',this.idiomaNativo);

  }

envioCorreoAyudaRT(){
this.modalSendEmail();
let data:any={
  productoId:this.datos.productoId,
  lang:this.idiomaNativo,
  texto:this.description,
}
this.datos.tipoProducto==68 ? data.fullName='Andres Martiez':'';
this.datos.tipoProducto==68 ? data.email='mtzprzandres@gmail.com':'';
console.log("DATOS",data);
if (this.datos.tipoRT) {
  this.reqService.sendEmailHelpRTExtern(this.datos.empresaId, data).subscribe((respuesta:any) => {
    console.log("getFormTI:",respuesta);
    Swal.close();
    this.dialogRef.close();
    if(respuesta.success){
    }
  });

}else{
  this.reqService.sendEmailHelpRT(this.datos.empresaId, data).subscribe((respuesta:any) => {
    console.log("getFormTI:",respuesta);
    Swal.close();
    this.dialogRef.close();
    if(respuesta.success){
    }
  });

}

}

modalSendEmail(){
  let textSendEmail='REQUERIMIENTOSV3.MODA_SEN_EMAI';
  this.translateSrv.get(textSendEmail).subscribe((res: string) => { textSendEmail = res; });
   // this.translate.get('CERTIFICAR.FORALL.CARGANDO_PRACTICA').subscribe((res: string) => { mensaje = res; });
console.log(this.urlAssetsEmail+'platform/img/tenor.gif');
  Swal.fire({
    imageUrl:this.urlAssetsEmail+'platform/img/tenor.gif',
    title: textSendEmail,
    allowOutsideClick: false,
    imageWidth: 100,
    imageHeight: 90,
    showConfirmButton:false

  });
}

}
